module.exports = __webpack_public_path__ + "img/home-banner2.d7af3aa0.png";